import React from "react";

const SIM = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="m29.805 8.862-6.67-6.667a.666.666 0 0 0-.47-.195H8.666A2.67 2.67 0 0 0 6 4.667v26.666A2.67 2.67 0 0 0 8.667 34h18.666A2.67 2.67 0 0 0 30 31.333v-22a.666.666 0 0 0-.195-.471ZM16 14.667a.665.665 0 0 1 .667-.667h2.666a.665.665 0 0 1 .667.667v2.666a.667.667 0 0 1-.667.667h-2.666a.667.667 0 0 1-.667-.667v-2.666ZM10 16c0-1.103.897-2 2-2h2a.665.665 0 0 1 .667.667v2.666A.67.67 0 0 1 14 18h-3.333a.667.667 0 0 1-.667-.667V16Zm4 13.333a.665.665 0 0 1-.667.667H12c-1.103 0-2-.897-2-2v-1.333a.666.666 0 0 1 .667-.667h2.666a.665.665 0 0 1 .667.667v2.666Zm5.333 0a.665.665 0 0 1-.666.667H16a.665.665 0 0 1-.667-.667v-2.666A.67.67 0 0 1 16 26h2.667a.667.667 0 0 1 .666.667v2.666ZM26 28c0 1.103-.897 2-2 2h-2.667a.665.665 0 0 1-.666-.667v-4a.667.667 0 0 0-.667-.666h-9.333A.665.665 0 0 1 10 24v-4a.666.666 0 0 1 .667-.667h14.666A.665.665 0 0 1 26 20v8Zm0-10.667a.665.665 0 0 1-.667.667H22a.665.665 0 0 1-.667-.667v-2.666A.67.67 0 0 1 22 14h2c1.103 0 2 .897 2 2v1.333Z"
            fill={fill}
        />

    </svg>
);

export default SIM;
